(function () {
    if (window.__kremLabCartSalesDocumentInit) return;
    window.__kremLabCartSalesDocumentInit = true;

    const DOCUMENT_PARAGON = 'Paragon';
    const DOCUMENT_COMPANY = 'Faktura na firmę';
    const DOCUMENT_PERSONAL = 'Faktura imienna';
    const VALID_DOCUMENTS = [DOCUMENT_PARAGON, DOCUMENT_COMPANY, DOCUMENT_PERSONAL];
    const ATTR_KEYS = {
        salesDocument: 'sales_document',
        customerNote: 'customer_note_raw',
        companyNip: 'company_nip',
        parcelLockerMode: 'parcel_locker_mode',
        parcelLockerCarrier: 'parcel_locker_carrier',
        parcelLockerLabel: 'parcel_locker_label',
        termsAcceptance: 'Akceptacja regulaminu',
    };
    const ACCELERATED_DISABLED_CLASS = 'sales-document__accelerated-pending';
    const SYNC_DELAY = 250;

    const CONTEXTS = [
        {
            key: 'drawer',
            rootSelector: '#CartDrawerSection',
            formId: 'cartDrawerForm',
            noteSelector: '#Cart-drawer-note-ui',
            salesSelector: '#CartDrawerSalesDocument',
            nipSelector: '#CartDrawer-company-nip',
            nipErrorSelector: '#CartDrawer-company-nip-error',
            termsSelector: '#cart-drawer-checkout-button-confirmation',
            parcelContext: 'drawer',
        },
        {
            key: 'cart',
            rootSelector: '#MainCartFooter',
            formId: 'cart',
            noteSelector: '#Cart-note-ui',
            salesSelector: '#CartPageSalesDocument',
            nipSelector: '#Cart-company-nip',
            nipErrorSelector: '#Cart-company-nip-error',
            termsSelector: '#cart-checkout-button-confirmation',
            parcelContext: 'cart',
        },
    ];

    let syncTimer = null;
    let syncInFlight = null;
    let hasPendingChanges = false;
    let lastSyncFailed = false;
    let checkoutSubmitInProgress = false;
    let notificationCheckoutSubmitInProgress = false;
    let shouldShowNipError = false;
    let lastSyncedSignature = '';
    let hydrationComplete = false;
    let lastInteractionContextKey = 'cart';
    let currentCustomerNote = '';
    let currentCompanyNip = '';

    function rawString(value) {
        return typeof value === 'string' ? value : String(value ?? '');
    }

    function normalize(value) {
        return rawString(value).replace(/\s+/g, ' ').trim();
    }

    function sanitizeNoteSegment(value) {
        return normalize(
            rawString(value)
                .replace(/\|+/g, ' / ')
                .replace(/[\r\n]+/g, ' ')
        );
    }

    function normalizeNip(value) {
        return rawString(value).replace(/\D+/g, '').slice(0, 10);
    }

    function isValidDocument(value) {
        return VALID_DOCUMENTS.includes(normalize(value));
    }

    function isValidNip(value) {
        const nip = normalizeNip(value);
        if (!/^\d{10}$/.test(nip)) return false;

        const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        const checksum =
            weights.reduce(function (sum, weight, index) {
                return sum + weight * Number(nip[index]);
            }, 0) % 11;

        return checksum !== 10 && checksum === Number(nip[9]);
    }

    function getRoot(context) {
        return document.querySelector(context.rootSelector);
    }

    function getForm(context) {
        return document.getElementById(context.formId);
    }

    function getAllContexts() {
        return CONTEXTS.filter(function (context) {
            return getRoot(context);
        });
    }

    function getContextByKey(key) {
        return (
            CONTEXTS.find(function (context) {
                return context.key === key;
            }) || null
        );
    }

    function getPreferredContext(context) {
        if (context && getRoot(context)) return context;

        const lastContext = getContextByKey(lastInteractionContextKey);
        if (lastContext && getRoot(lastContext)) return lastContext;

        return getAllContexts()[0] || context || lastContext || CONTEXTS[0];
    }

    function getContextFromElement(element) {
        if (!element) return null;

        return (
            CONTEXTS.find(function (context) {
                return element.closest(context.rootSelector);
            }) || null
        );
    }

    function getVisibleNoteField(context) {
        const root = getRoot(context);
        return root ? root.querySelector(context.noteSelector) : null;
    }

    function getCompanyNipField(context) {
        const root = getRoot(context);
        return root ? root.querySelector(context.nipSelector) : null;
    }

    function getCompanyNipContainer(context) {
        const root = getRoot(context);
        return root ? root.querySelector('[data-sales-document-company-nip]') : null;
    }

    function getCompanyNipErrorElement(context) {
        const root = getRoot(context);
        return root ? root.querySelector(context.nipErrorSelector) : null;
    }

    function getTermsCheckbox(context) {
        const root = getRoot(context);
        return root ? root.querySelector(context.termsSelector) : null;
    }

    function getSalesDocumentInputs(context) {
        const root = getRoot(context);
        return root ? Array.from(root.querySelectorAll(`${context.salesSelector} input[name="sales_document"]`)) : [];
    }

    function getSelectedSalesDocument(context) {
        const checked = getSalesDocumentInputs(context).find(function (input) {
            return input.checked;
        });
        const value = checked ? normalize(checked.value) : DOCUMENT_PARAGON;
        return isValidDocument(value) ? value : DOCUMENT_PARAGON;
    }

    function setSelectedSalesDocument(context, value) {
        const finalValue = isValidDocument(value) ? normalize(value) : DOCUMENT_PARAGON;

        getSalesDocumentInputs(context).forEach(function (input) {
            input.checked = normalize(input.value) === finalValue;
        });
    }

    function setSelectedDocumentEverywhere(value) {
        getAllContexts().forEach(function (context) {
            setSelectedSalesDocument(context, value);
        });
    }

    function syncVisibleCustomerNote(value, exceptField) {
        getAllContexts().forEach(function (context) {
            const field = getVisibleNoteField(context);
            if (field && field !== exceptField && field.value !== value) {
                field.value = value;
            }
        });
    }

    function syncVisibleCompanyNip(value, exceptField) {
        getAllContexts().forEach(function (context) {
            const field = getCompanyNipField(context);
            if (field && field !== exceptField && field.value !== value) {
                field.value = value;
            }
        });
    }

    function syncTermsAccepted(accepted, exceptField) {
        getAllContexts().forEach(function (context) {
            const checkbox = getTermsCheckbox(context);
            if (checkbox && checkbox !== exceptField) {
                checkbox.checked = accepted;
                if (typeof checkbox.onchange === 'function') {
                    checkbox.onchange.call(checkbox);
                }
            }
        });
    }

    function updateCompanyNipVisibility(documentValue) {
        const isCompanyInvoice = documentValue === DOCUMENT_COMPANY;

        getAllContexts().forEach(function (context) {
            const container = getCompanyNipContainer(context);
            if (container) {
                container.hidden = !isCompanyInvoice;
            }
        });
    }

    function updateCompanyNipErrors(validation) {
        getAllContexts().forEach(function (context) {
            const field = getCompanyNipField(context);
            const error = getCompanyNipErrorElement(context);

            if (field) {
                field.toggleAttribute('aria-invalid', Boolean(validation.nipError));
            }

            if (error) {
                if (validation.nipError) {
                    error.textContent = validation.nipError;
                    error.hidden = false;
                } else {
                    error.textContent = '';
                    error.hidden = true;
                }
            }
        });
    }

    function toggleAcceleratedCheckoutButtons(disabled) {
        document
            .querySelectorAll('.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons')
            .forEach(function (element) {
                element.classList.toggle(ACCELERATED_DISABLED_CLASS, disabled);
                element.setAttribute('aria-disabled', disabled ? 'true' : 'false');
                element.toggleAttribute('inert', disabled);
            });
    }

    function getParcelLockerContainer(context) {
        const root = getRoot(context);
        return root
            ? root.querySelector(`[data-parcel-locker][data-parcel-locker-context="${context.parcelContext}"]`)
            : null;
    }

    function getParcelLockerSelectedPrefixes(context) {
        const container = getParcelLockerContainer(context);
        if (!container) return [];

        return [
            container.dataset.parcelLockerSelectedPrefix,
            container.dataset.parcelLockerSelectedPrefixInpost,
            container.dataset.parcelLockerSelectedPrefixOrlen,
        ]
            .map(normalize)
            .filter(Boolean);
    }

    function stripParcelLockerPrefix(value, context) {
        let result = normalize(value);

        getParcelLockerSelectedPrefixes(context).forEach(function (selectedPrefix) {
            if (result.toLowerCase().startsWith(selectedPrefix.toLowerCase())) {
                result = normalize(result.slice(selectedPrefix.length));
            }
        });

        result = result.replace(/^:\s*/, '');
        result = result.replace(/^Wybrany punkt\s*:?\s*/i, '');
        result = result.replace(/^Punkt odbioru InPost\s*:?\s*/i, '');
        result = result.replace(/^Wybrany punkt InPost\s*:?\s*/i, '');
        result = result.replace(/^Wybrany punkt ORLEN Paczka\s*:?\s*/i, '');
        result = result.replace(/^ORLEN Paczka\s*:?\s*/i, '');

        return normalize(result);
    }

    function getDomParcelLockerMode(context) {
        const container = getParcelLockerContainer(context);
        if (!container) return '';

        const checked = container.querySelector('[data-parcel-locker-mode-input]:checked');
        return checked ? normalize(checked.value) : '';
    }

    function getCarrierForParcelLockerMode(mode) {
        const normalizedMode = normalize(mode);
        if (normalizedMode === 'courier') return 'inpost';
        if (normalizedMode === 'pickup') return 'inpost';
        if (normalizedMode === 'orlen') return 'orlen';
        return '';
    }

    function getDomParcelLockerCarrier(context) {
        return getCarrierForParcelLockerMode(getDomParcelLockerMode(context));
    }

    function isParcelLockerPickupMode(mode) {
        const normalizedMode = normalize(mode);
        return normalizedMode === 'pickup' || normalizedMode === 'orlen';
    }

    function getDomParcelLockerLabelRaw(context) {
        const container = getParcelLockerContainer(context);
        if (!container) return '';

        const labelElement = container.querySelector('[data-parcel-locker-label]');
        return labelElement ? normalize(labelElement.textContent) : '';
    }

    function getDocumentFromNote(note) {
        const firstPart = normalize(note).split('|')[0];
        return isValidDocument(firstPart) ? firstPart : '';
    }

    function formatCompanyNipSegment(nip) {
        return nip ? `NIP: ${nip}` : '';
    }

    function getCompanyNipFromSegment(segment) {
        const match = normalize(segment).match(/^NIP\s*:?\s*(\d{10})$/i);
        return match ? match[1] : '';
    }

    function getCarrierFromSegment(segment) {
        const value = normalize(segment).toLowerCase();
        if (value === 'inpost' || value === 'inpost kurier/paczkomat') return 'inpost';
        if (value === 'orlen' || value === 'orlen paczka') return 'orlen';
        return '';
    }

    function formatParcelCarrierSegment(carrier) {
        if (carrier === 'inpost') return 'Inpost';
        if (carrier === 'orlen') return 'Orlen';
        return '';
    }

    function isParcelLockerSegment(segment, context, rawLabel, cleanLabel) {
        const value = normalize(segment);
        if (!value) return false;

        const normalizedRawLabel = normalize(rawLabel);
        const normalizedCleanLabel = normalize(cleanLabel);

        if (normalizedRawLabel && value === normalizedRawLabel) return true;
        if (normalizedCleanLabel && value === normalizedCleanLabel) return true;

        if (/^Wybrany punkt\s*:?\s*/i.test(value)) return true;
        if (/^Punkt odbioru InPost\s*:?\s*/i.test(value)) return true;
        if (/^Wybrany punkt InPost\s*:?\s*/i.test(value)) return true;
        if (/^Wybrany punkt ORLEN Paczka\s*:?\s*/i.test(value)) return true;
        if (/^ORLEN Paczka\s*:?\s*/i.test(value)) return true;

        const stripped = stripParcelLockerPrefix(value, context);
        if (normalizedCleanLabel && stripped === normalizedCleanLabel) return true;

        return false;
    }

    function extractCompanyNipFromFinalNote(fullNote, documentLabel) {
        const note = normalize(fullNote);
        if (!note || documentLabel !== DOCUMENT_COMPANY) return '';

        let parts = note.split('|').map(normalize).filter(Boolean);
        if (!parts.length) return '';

        if (parts[0] === documentLabel) {
            parts = parts.slice(1);
        }

        return parts.length ? getCompanyNipFromSegment(parts[0]) : '';
    }

    function extractCustomerNoteFromFinalNote(fullNote, context, documentLabel, rawLabel, cleanLabel) {
        const note = normalize(fullNote);
        if (!note) return '';

        let parts = note.split('|').map(normalize).filter(Boolean);
        if (!parts.length) return '';

        if (documentLabel && parts[0] === documentLabel) {
            parts = parts.slice(1);
        }

        if (parts.length && getCompanyNipFromSegment(parts[0])) {
            parts = parts.slice(1);
        }

        if (parts.length && getCarrierFromSegment(parts[0])) {
            parts = parts.slice(1);
        }

        if (parts.length && isParcelLockerSegment(parts[0], context, rawLabel, cleanLabel)) {
            parts = parts.slice(1);
        }

        return parts.join(' | ');
    }

    function composeFinalNote(state) {
        const documentLabel = isValidDocument(state.salesDocument) ? normalize(state.salesDocument) : DOCUMENT_PARAGON;
        const parcelLockerMode = normalize(state.parcelLockerMode);
        const parcelLockerCarrier = normalize(state.parcelLockerCarrier) || getCarrierForParcelLockerMode(parcelLockerMode);
        const parcelLockerLabel = sanitizeNoteSegment(state.parcelLockerLabel);
        const customerNote = sanitizeNoteSegment(state.customerNoteRaw);
        const companyNip = normalizeNip(state.companyNip);
        const parts = [documentLabel];

        if (documentLabel === DOCUMENT_COMPANY && companyNip) {
            parts.push(formatCompanyNipSegment(companyNip));
        }

        const carrierSegment = formatParcelCarrierSegment(parcelLockerCarrier);
        if (carrierSegment) {
            parts.push(carrierSegment);
        }

        if (isParcelLockerPickupMode(parcelLockerMode) && parcelLockerLabel) {
            parts.push(parcelLockerLabel);
        }

        if (customerNote) {
            parts.push(customerNote);
        }

        return parts.join(' | ');
    }

    function createStateSignature(state) {
        return JSON.stringify({
            salesDocument: state.salesDocument,
            companyNip: normalizeNip(state.companyNip),
            customerNoteRaw: rawString(state.customerNoteRaw),
            parcelLockerMode: normalize(state.parcelLockerMode),
            parcelLockerCarrier: normalize(state.parcelLockerCarrier),
            parcelLockerLabel: normalize(state.parcelLockerLabel),
            termsRequired: Boolean(state.termsRequired),
            termsAccepted: Boolean(state.termsAccepted),
            finalNote: state.finalNote,
        });
    }

    function getCartAttributes(cartData) {
        return cartData && cartData.attributes ? cartData.attributes : {};
    }

    function getExpectedTermsAcceptance(state) {
        return state.termsAccepted ? 'Tak' : '';
    }

    function cartPayloadMatchesState(cartData, state) {
        const cartAttributes = getCartAttributes(cartData);

        return (
            normalize(cartData && cartData.note) === normalize(state.finalNote) &&
            normalize(cartAttributes[ATTR_KEYS.salesDocument]) === normalize(state.salesDocument) &&
            rawString(cartAttributes[ATTR_KEYS.customerNote]) === rawString(state.customerNoteRaw) &&
            normalizeNip(cartAttributes[ATTR_KEYS.companyNip]) === normalizeNip(state.companyNip) &&
            normalize(cartAttributes[ATTR_KEYS.parcelLockerMode]) === normalize(state.parcelLockerMode) &&
            normalize(cartAttributes[ATTR_KEYS.parcelLockerCarrier]) === normalize(state.parcelLockerCarrier) &&
            normalize(cartAttributes[ATTR_KEYS.parcelLockerLabel]) === normalize(state.parcelLockerLabel) &&
            normalize(cartAttributes[ATTR_KEYS.termsAcceptance]) === getExpectedTermsAcceptance(state)
        );
    }

    function isCartPayloadReady(state) {
        return (
            hydrationComplete &&
            Boolean(lastSyncedSignature) &&
            state.signature === lastSyncedSignature &&
            !hasPendingChanges &&
            !lastSyncFailed &&
            !syncInFlight
        );
    }

    function buildStateSnapshot(preferredContext, cartData) {
        const context = getPreferredContext(preferredContext);
        const cartAttributes = getCartAttributes(cartData);
        const selectedDocument = getSelectedSalesDocument(context);
        const noteField = getVisibleNoteField(context);
        const nipField = getCompanyNipField(context);
        const termsCheckbox = getTermsCheckbox(context);
        const rawParcelLockerLabel =
            getDomParcelLockerLabelRaw(context) || normalize(cartAttributes[ATTR_KEYS.parcelLockerLabel]);
        const domParcelLockerMode = getDomParcelLockerMode(context);
        const attributeParcelLockerMode = normalize(cartAttributes[ATTR_KEYS.parcelLockerMode]);
        const parcelLockerMode = cartData
            ? attributeParcelLockerMode || domParcelLockerMode
            : domParcelLockerMode || attributeParcelLockerMode;
        const domParcelLockerCarrier = getDomParcelLockerCarrier(context);
        const attributeParcelLockerCarrier = normalize(cartAttributes[ATTR_KEYS.parcelLockerCarrier]);
        const parcelLockerCarrier =
            (cartData ? attributeParcelLockerCarrier || domParcelLockerCarrier : domParcelLockerCarrier || attributeParcelLockerCarrier) ||
            getCarrierForParcelLockerMode(parcelLockerMode);

        const state = {
            salesDocument: selectedDocument,
            customerNoteRaw: noteField ? noteField.value : currentCustomerNote,
            companyNip: nipField ? normalizeNip(nipField.value) : currentCompanyNip,
            parcelLockerMode,
            parcelLockerCarrier,
            parcelLockerLabel: stripParcelLockerPrefix(rawParcelLockerLabel, context),
            termsRequired: Boolean(termsCheckbox),
            termsAccepted: termsCheckbox ? termsCheckbox.checked : normalize(cartAttributes[ATTR_KEYS.termsAcceptance]) === 'Tak',
        };

        state.finalNote = composeFinalNote(state);
        state.signature = createStateSignature(state);

        return state;
    }

    function getValidation(state, options) {
        const forceShowError = Boolean(options && options.forceShowNipError);
        const requiresCompanyNip = state.salesDocument === DOCUMENT_COMPANY;
        const companyNip = normalizeNip(state.companyNip);
        const companyNipValid = !requiresCompanyNip || isValidNip(companyNip);
        const requiresParcelLockerSelection =
            isParcelLockerPickupMode(state.parcelLockerMode) && !normalize(state.parcelLockerLabel);
        const requiresTermsAcceptance = Boolean(state.termsRequired) && !state.termsAccepted;
        const payloadReady = isCartPayloadReady(state);
        let nipError = '';

        if (requiresCompanyNip) {
            if (!companyNip && forceShowError) {
                nipError = 'Podaj NIP do faktury na firmę.';
            } else if (companyNip && !companyNipValid) {
                nipError = 'Wpisz poprawny 10-cyfrowy NIP.';
            }
        }

        return {
            nipError,
            parcelLockerError: requiresParcelLockerSelection ? 'Wybierz punkt odbioru.' : '',
            termsError: requiresTermsAcceptance ? 'Zaakceptuj regulamin i politykę prywatności.' : '',
            payloadReady,
            canCheckout: !nipError && !requiresParcelLockerSelection && !requiresTermsAcceptance,
            shouldDisableAccelerated:
                !payloadReady ||
                Boolean(syncInFlight) ||
                hasPendingChanges ||
                lastSyncFailed ||
                (requiresCompanyNip && !companyNipValid) ||
                requiresParcelLockerSelection ||
                requiresTermsAcceptance,
        };
    }

    function requestParcelLockerSelection(context) {
        document.dispatchEvent(
            new CustomEvent('krem:parcel-locker-selection-required', {
                detail: context ? { context: context.key } : {},
            })
        );
    }

    function updateUi(preferredContext, options) {
        const state = buildStateSnapshot(preferredContext);
        const validation = getValidation(state, options || { forceShowNipError: shouldShowNipError });

        updateCompanyNipVisibility(state.salesDocument);
        updateCompanyNipErrors(validation);
        toggleAcceleratedCheckoutButtons(validation.shouldDisableAccelerated);

        return {
            state,
            validation,
        };
    }

    async function fetchCart() {
        const response = await fetch('/cart.js', {
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Nie udało się pobrać danych koszyka.');
        }

        return response.json();
    }

    async function persistCartState(state) {
        const cart = await fetchCart();
        const mergedAttributes = {
            ...getCartAttributes(cart),
            [ATTR_KEYS.salesDocument]: state.salesDocument,
            [ATTR_KEYS.customerNote]: rawString(state.customerNoteRaw),
            [ATTR_KEYS.companyNip]: normalizeNip(state.companyNip),
            [ATTR_KEYS.parcelLockerMode]: normalize(state.parcelLockerMode),
            [ATTR_KEYS.parcelLockerCarrier]: normalize(state.parcelLockerCarrier),
            [ATTR_KEYS.parcelLockerLabel]: normalize(state.parcelLockerLabel),
            [ATTR_KEYS.termsAcceptance]: state.termsAccepted ? 'Tak' : '',
        };

        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                note: state.finalNote,
                attributes: mergedAttributes,
            }),
        });

        if (!response.ok) {
            throw new Error('Nie udało się zapisać danych koszyka.');
        }

        return response.json();
    }

    async function ensureStateSynchronized(preferredContext, options) {
        const forceSync = Boolean(options && options.force);
        const snapshot = buildStateSnapshot(preferredContext);

        if (
            !forceSync &&
            hydrationComplete &&
            !hasPendingChanges &&
            !lastSyncFailed &&
            !syncInFlight &&
            snapshot.signature === lastSyncedSignature
        ) {
            return snapshot;
        }

        if (syncTimer) {
            window.clearTimeout(syncTimer);
            syncTimer = null;
        }

        if (syncInFlight) {
            await syncInFlight;
        }

        const nextSnapshot = buildStateSnapshot(preferredContext);
        const nextSignature = nextSnapshot.signature;

        if (
            !forceSync &&
            hydrationComplete &&
            !hasPendingChanges &&
            !lastSyncFailed &&
            nextSignature === lastSyncedSignature
        ) {
            return nextSnapshot;
        }

        hasPendingChanges = false;
        lastSyncFailed = false;
        updateUi(preferredContext, { forceShowNipError: shouldShowNipError });

        syncInFlight = persistCartState(nextSnapshot)
            .then(function (updatedCart) {
                if (!cartPayloadMatchesState(updatedCart, nextSnapshot)) {
                    throw new Error('Shopify nie potwierdził zapisu kompletnej notatki koszyka.');
                }
                currentCustomerNote = rawString(nextSnapshot.customerNoteRaw);
                currentCompanyNip = normalizeNip(nextSnapshot.companyNip);
                lastSyncedSignature = nextSignature;
                hydrationComplete = true;
                lastSyncFailed = false;
            })
            .catch(function (error) {
                lastSyncFailed = true;
                throw error;
            })
            .finally(function () {
                syncInFlight = null;
                updateUi(preferredContext, { forceShowNipError: shouldShowNipError });
            });

        await syncInFlight;
        return buildStateSnapshot(preferredContext);
    }

    function scheduleSync(preferredContext, immediate) {
        lastInteractionContextKey = getPreferredContext(preferredContext).key;
        hasPendingChanges = true;
        lastSyncFailed = false;
        updateUi(preferredContext, { forceShowNipError: shouldShowNipError });

        if (syncTimer) {
            window.clearTimeout(syncTimer);
        }

        if (immediate) {
            ensureStateSynchronized(preferredContext).catch(function (error) {
                console.warn('[Sales document] Nie udało się zsynchronizować danych koszyka.', error);
                updateUi(preferredContext, { forceShowNipError: shouldShowNipError });
            });
            return;
        }

        syncTimer = window.setTimeout(function () {
            ensureStateSynchronized(preferredContext).catch(function (error) {
                console.warn('[Sales document] Nie udało się zsynchronizować danych koszyka.', error);
                updateUi(preferredContext, { forceShowNipError: shouldShowNipError });
            });
        }, SYNC_DELAY);
    }

    async function hydrateContexts() {
        const contexts = getAllContexts();
        hydrationComplete = false;
        toggleAcceleratedCheckoutButtons(true);

        if (!contexts.length) {
            hydrationComplete = true;
            return;
        }

        const cart = await fetchCart();
        const cartAttributes = getCartAttributes(cart);
        const fallbackContext = getPreferredContext();
        const rawLabel =
            normalize(cartAttributes[ATTR_KEYS.parcelLockerLabel]) || getDomParcelLockerLabelRaw(fallbackContext);
        const cleanLabel = stripParcelLockerPrefix(rawLabel, fallbackContext);
        const attributeDocument = normalize(cartAttributes[ATTR_KEYS.salesDocument]);
        const noteDocument = getDocumentFromNote(cart.note || '');
        const resolvedDocument = isValidDocument(attributeDocument)
            ? attributeDocument
            : noteDocument || DOCUMENT_PARAGON;
        const hasStoredCustomerNote = Object.prototype.hasOwnProperty.call(cartAttributes, ATTR_KEYS.customerNote);
        const attributeCustomerNote = hasStoredCustomerNote ? rawString(cartAttributes[ATTR_KEYS.customerNote]) : '';
        const fallbackCustomerNote = extractCustomerNoteFromFinalNote(
            cart.note || '',
            fallbackContext,
            resolvedDocument,
            rawLabel,
            cleanLabel
        );
        const attributeCompanyNip = normalizeNip(cartAttributes[ATTR_KEYS.companyNip]);
        const fallbackCompanyNip = extractCompanyNipFromFinalNote(cart.note || '', resolvedDocument);

        currentCustomerNote = hasStoredCustomerNote ? attributeCustomerNote : fallbackCustomerNote;
        currentCompanyNip = attributeCompanyNip || fallbackCompanyNip;
        shouldShowNipError = false;
        hasPendingChanges = false;
        lastSyncFailed = false;

        setSelectedDocumentEverywhere(resolvedDocument);
        syncVisibleCustomerNote(currentCustomerNote);
        syncVisibleCompanyNip(currentCompanyNip);
        updateCompanyNipVisibility(resolvedDocument);
        updateCompanyNipErrors({ nipError: '' });

        const state = buildStateSnapshot(fallbackContext, cart);
        const needsCartPayloadSync = cart.item_count > 0 && !cartPayloadMatchesState(cart, state);
        lastSyncedSignature = needsCartPayloadSync ? '' : state.signature;
        hydrationComplete = true;

        updateUi(fallbackContext, { forceShowNipError: false });

        if (needsCartPayloadSync) {
            scheduleSync(fallbackContext, true);
        }
    }

    function focusCompanyNipField(preferredContext) {
        const context = getPreferredContext(preferredContext);
        const field = getCompanyNipField(context);
        if (!field) return;

        const container = getCompanyNipContainer(context);
        if (container && container.hidden) {
            container.hidden = false;
        }

        field.focus();
        field.select();
    }

    function focusTermsCheckbox(preferredContext) {
        const context = getPreferredContext(preferredContext);
        const checkbox = getTermsCheckbox(context);
        if (!checkbox) return;

        checkbox.focus();
        checkbox.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }

    function submitCheckoutForm(form, submitter) {
        if (typeof form.requestSubmit === 'function' && submitter) {
            form.requestSubmit(submitter);
            return;
        }

        const fallbackSubmitter = document.createElement('input');
        fallbackSubmitter.type = 'hidden';
        fallbackSubmitter.name = 'checkout';
        fallbackSubmitter.value = 'checkout';
        form.appendChild(fallbackSubmitter);
        form.submit();
    }

    function handleCheckoutValidationFailure(validation, context) {
        if (validation.nipError) {
            focusCompanyNipField(context);
        }

        if (validation.parcelLockerError) {
            requestParcelLockerSelection(context);
        }

        if (validation.termsError) {
            focusTermsCheckbox(context);
        }
    }

    async function prepareCheckout(context) {
        if (window.kremLabCartGifts && typeof window.kremLabCartGifts.normalize === 'function') {
            await window.kremLabCartGifts.normalize();
        }

        await ensureStateSynchronized(context, { force: true });

        const nextUiState = updateUi(context, { forceShowNipError: true });
        if (!nextUiState.validation.canCheckout || !nextUiState.validation.payloadReady || lastSyncFailed) {
            handleCheckoutValidationFailure(nextUiState.validation, context);
            return false;
        }

        return true;
    }

    document.addEventListener('input', function (event) {
        const noteField = event.target.closest('#Cart-note-ui, #Cart-drawer-note-ui');
        if (noteField) {
            const context = getContextFromElement(noteField);
            currentCustomerNote = noteField.value;
            syncVisibleCustomerNote(currentCustomerNote, noteField);
            scheduleSync(context, false);
            return;
        }

        const nipField = event.target.closest('#Cart-company-nip, #CartDrawer-company-nip');
        if (!nipField) return;

        const context = getContextFromElement(nipField);
        currentCompanyNip = normalizeNip(nipField.value);
        nipField.value = currentCompanyNip;
        syncVisibleCompanyNip(currentCompanyNip, nipField);
        shouldShowNipError = currentCompanyNip.length > 0;
        scheduleSync(context, false);
    });

    document.addEventListener(
        'blur',
        function (event) {
            const noteField = event.target.closest('#Cart-note-ui, #Cart-drawer-note-ui');
            if (noteField) {
                const context = getContextFromElement(noteField);
                currentCustomerNote = noteField.value;
                syncVisibleCustomerNote(currentCustomerNote, noteField);
                scheduleSync(context, true);
                return;
            }

            const nipField = event.target.closest('#Cart-company-nip, #CartDrawer-company-nip');
            if (!nipField) return;

            const context = getContextFromElement(nipField);
            currentCompanyNip = normalizeNip(nipField.value);
            nipField.value = currentCompanyNip;
            syncVisibleCompanyNip(currentCompanyNip, nipField);
            shouldShowNipError = true;
            scheduleSync(context, true);
        },
        true
    );

    document.addEventListener('change', function (event) {
        const termsCheckbox = event.target.closest('[data-kremlab-terms-input]');
        if (termsCheckbox) {
            const context = getContextFromElement(termsCheckbox);
            syncTermsAccepted(termsCheckbox.checked, termsCheckbox);
            scheduleSync(context, true);
            return;
        }

        const salesDocumentInput = event.target.closest('input[name="sales_document"]');
        if (!salesDocumentInput) return;

        const context = getContextFromElement(salesDocumentInput);
        if (!context) return;

        setSelectedDocumentEverywhere(salesDocumentInput.value);
        shouldShowNipError = false;
        updateUi(context, { forceShowNipError: false });
        scheduleSync(context, true);
    });

    document.addEventListener(
        'click',
        function (event) {
            const acceleratedCheckout = event.target.closest(
                '.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons'
            );
            if (!acceleratedCheckout) return;

            const context = getContextFromElement(acceleratedCheckout) || getPreferredContext();
            const currentUiState = updateUi(context, { forceShowNipError: true });
            if (
                currentUiState.validation.canCheckout &&
                currentUiState.validation.payloadReady &&
                !currentUiState.validation.shouldDisableAccelerated
            ) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }

            shouldShowNipError = true;
            handleCheckoutValidationFailure(currentUiState.validation, context);

            if (currentUiState.validation.canCheckout && !currentUiState.validation.payloadReady) {
                prepareCheckout(context).catch(function (error) {
                    console.warn('[Sales document] Nie udało się przygotować szybkiej płatności.', error);
                    updateUi(context, { forceShowNipError: shouldShowNipError });
                });
            }
        },
        true
    );

    document.addEventListener(
        'click',
        async function (event) {
            const checkoutButton = event.target.closest('[data-cart-standard-checkout]');
            if (!checkoutButton) return;

            const context = getContextFromElement(checkoutButton);
            const form = context ? getForm(context) : null;
            if (!context || !form || checkoutButton.disabled || checkoutSubmitInProgress) return;

            event.preventDefault();
            shouldShowNipError = true;

            const currentUiState = updateUi(context, { forceShowNipError: true });
            if (!currentUiState.validation.canCheckout) {
                handleCheckoutValidationFailure(currentUiState.validation, context);
                return;
            }

            try {
                checkoutSubmitInProgress = true;

                const readyForCheckout = await prepareCheckout(context);
                if (!readyForCheckout) {
                    return;
                }

                submitCheckoutForm(form, checkoutButton);
            } catch (error) {
                console.warn('[Sales document] Nie udało się przejść do checkoutu po synchronizacji koszyka.', error);
            } finally {
                checkoutSubmitInProgress = false;
                updateUi(context, { forceShowNipError: shouldShowNipError });
            }
        },
        true
    );

    document.addEventListener(
        'click',
        async function (event) {
            const checkoutButton = event.target.closest('#cart-notification-form [name="checkout"]');
            if (!checkoutButton) return;

            const form = checkoutButton.form || document.getElementById('cart-notification-form');
            const context = getPreferredContext();
            if (!form || checkoutButton.disabled || notificationCheckoutSubmitInProgress) return;

            event.preventDefault();
            shouldShowNipError = true;

            const currentUiState = updateUi(context, { forceShowNipError: true });
            if (!currentUiState.validation.canCheckout) {
                handleCheckoutValidationFailure(currentUiState.validation, context);
                return;
            }

            try {
                notificationCheckoutSubmitInProgress = true;

                const readyForCheckout = await prepareCheckout(context);
                if (!readyForCheckout) {
                    return;
                }

                submitCheckoutForm(form, checkoutButton);
            } catch (error) {
                console.warn('[Sales document] Nie udało się przejść do checkoutu z powiadomienia koszyka.', error);
            } finally {
                notificationCheckoutSubmitInProgress = false;
                updateUi(context, { forceShowNipError: shouldShowNipError });
            }
        },
        true
    );

    document.addEventListener('krem:parcel-locker-updated', function (event) {
        const preferredContext = getContextByKey(event.detail && event.detail.context);
        scheduleSync(preferredContext, true);
    });

    document.addEventListener('DOMContentLoaded', function () {
        hydrateContexts().catch(function (error) {
            console.warn('[Sales document] Nie udało się pobrać danych koszyka przy starcie.', error);
        });
    });

    document.addEventListener('shopify:section:load', function () {
        hydrateContexts().catch(function (error) {
            console.warn('[Sales document] Nie udało się pobrać danych koszyka po odświeżeniu sekcji.', error);
        });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdateFinish) {
        subscribe(PUB_SUB_EVENTS.cartUpdateFinish, function () {
            hydrateContexts().catch(function (error) {
                console.warn('[Sales document] Nie udało się pobrać danych koszyka po aktualizacji koszyka.', error);
            });
        });
    }
})();
